export interface BibliographyContentSortOrderUpdateRequest {
  bibliographyRealId: number
  bibliographyContents: {
    id: number
    revision: number
  }[]
}

export function BibliographyContentSortOrderUpdateRequestToJSON(
  value: BibliographyContentSortOrderUpdateRequest
): any {
  return {
    bibliography_real_id:
      value.bibliographyRealId !== 0 ? value.bibliographyRealId : undefined,
    bibliography_contents:
      value.bibliographyContents.length !== 0
        ? value.bibliographyContents.map(item => {
            return {
              id: item.id !== 0 ? item.id : undefined,
              revision: item.revision !== 0 ? item.revision : undefined
            }
          })
        : undefined
  }
}
